import React, { useEffect, useState } from "react";
import HeaderBanner from "../../components/header-banner/HeaderBanner";
import Discover from "../../components/discover/Discover";
import Chiffres from "../../components/chiffres/Chiffres";
import Footer from "../../components/footer/Footer";
import Partenaire from "../../components/partenaire/Partenaire";
import Apropos from "../../components/apropos/Apropos";
import EventsSlider from "../../components/EventsSlider/EventsSlider";
import client from "../../client/Client";
import ContactUs from "../../components/contactus/ContactUs";

const Home = ({ setSelectedEvent, setCurrentEvent }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    client
      .fetch('*[_type == "event"]')
      .then((result) => {
        setEvents(result);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, []);
  return (
    <>
      <HeaderBanner
        title={"Explorez les données scientifiques pour protéger l'eau et la biodiversité de Soliman."}
        colored={""}
        isHome={false}
      />
      <Discover />
      <Chiffres />
      <Partenaire />
      {/* {events && (
        <EventsSlider
          events={events}
          setSelectedEvent={setSelectedEvent}
          setCurrentEvent={setCurrentEvent}
        />
      )} */}
      <ContactUs />
      <Footer />
    </>
  );
};

export default Home;
